module.exports = __webpack_public_path__ + "static/media/Illustration.ae858190.svg";